import RestService from './_private/RestService';
import ServerConfig from '@core/models/country/ServerConfig';
import * as NetworkUtils from '@utils/network/NetworkUtils';
import { instanceGuard } from '@core/utils/services';
import SingletonError from '../common/errors/SingletonError';
import Singleton from '../common/Singleton';

class BonusService {

    private static instance: BonusService;

    public static getInstance(): BonusService {
        return instanceGuard(BonusService.instance);
    }

    public static createInstance(config: ServerConfig) {
        if (!BonusService.instance) {
            BonusService.instance = new BonusService(config);
        }
        return BonusService.instance;
    }

    private restService: RestService;

    private constructor(private config: ServerConfig) {
        if (BonusService.instance) {
            throw new SingletonError(this.constructor.name);
        }
        this.restService = new RestService(this.config);
    }

    public async setBonus(code: string): Promise<any> {
        if (code === 'NoBonus') {
            return NetworkUtils.processResponse(this.restService.setNoBonus());
        }
        return NetworkUtils.processResponse(await this.restService.setBonus(code));
    }

    public static clearInstance() {
        if (process.env.NODE_ENV !== 'test') {
            throw new Error('For use in tests only');
        }
        delete BonusService.instance;
    }
}

export default BonusService as Singleton<BonusService>;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/services/bonus/BonusService.ts